import axios from "@/request";
import qs from "qs";

export default {
  async total(params: any) {
    return axios.get("datav/total", { params });
  },
  async maptotal(params: any) {
    return axios.get("datav/map-total", { params });
  },
  async ai(params: any) {
    return axios.get("datav/ai", { params });
  },
  async activityLog(params: any) {
    return axios.get("datav/activity-log", { params });
  },
  async activityLog1(params: any) {
    return axios.get("datav/activity-log1", { params });
  },
  async activityLog2(params: any) {
    return axios.get("datav/activity-log2", { params });
  },
  async map(params: any) {
    return axios.get("datav/map", { params });
  },
  async stadium1(params: any) {
    return axios.get("datav/stadium1", { params });
  },
  async stadium2(params: any) {
    return axios.get("datav/stadium2", { params });
  },
  async stadium3(params: any) {
    return axios.get("datav/stadium3", { params });
  },
  async stadium4(params: any) {
    return axios.get("datav/stadium4", { params });
  },
  async stadium5(params: any) {
    return axios.get("datav/stadium5", { params });
  },
  async stadium6(params: any) {
    return axios.get("datav/stadium6", { params });
  },
  async stadium7(params: any) {
    return axios.get("datav/stadium7", { params });
  },
  async bill(params: any) {
    return axios.get("datav/bill", { params });
  },
  async stadiumDetail(params: any) {
    return axios.get("datav/stadium-detail", { params });
  },
  async stadiumTotal(params: any) {
    return axios.get("datav/stadium-total", { params });
  },
  async stadiumAI(params: any) {
    return axios.get("datav/stadium-ai", { params });
  },
  async stadiumCamera(params: any) {
    return axios.get("datav/stadium-camera", { params });
  },
  async graph(params: any) {
    return axios.get("datav/graph", { params });
  },
  async playrecordgraph(params: any) {
    return axios.get("datav/playrecord-graph", { params });
  },
  async playrecord(params: any) {
    return axios.get("datav/stadiumdetaillistdata", { params });
  },
  async money(params: any) {
    return axios.get("datav/stadiumdetaillistdata", { params });
  },
  async statBill(params: any) {
    return axios.get("stadium-statistics/bill", { params });
  },
  async statUser(params: any) {
    return axios.get("stadium-statistics/user", { params });
  },
  async statVip(params: any) {
    return axios.get("stadium-statistics/vip", { params });
  },
  async statBlock(params: any) {
    return axios.get("stadium-statistics/block", { params });
  },
  async statClub(params: any) {
    return axios.get("stadium-statistics/club", { params });
  },
  async statTrain(params: any) {
    return axios.get("stadium-statistics/train", { params });
  },
  async statBindWire(params: any) {
    return axios.get("stadium-statistics/wire", { params });
  },
  async statAccount(params: any) {
    return axios.get("stadium-statistics/account", { params });
  },
  async summaryBusiness(params: any) {
    return axios.get("stadium-statistics/business", { params });
  },
  async summaryManagement(params: any) {
    return axios.get("stadium-statistics/management", { params });
  },
  async userData(params: any) {
    return axios.get("datav/user-data", { params });
  },
  async billType(params: any) {
    return axios.get("datav/bill-type", { params });
  },
  async stadiumground(params: any) {
    return axios.get("datav/stadium-ground", { params });
  },
  async groundbroadcast(params: any) {
    return axios.get("datav/ground-broadcast", { params });
  }
};
